export const pushConfig = `
{
  "pushServerURL": "__SERVERURL__",
  "ios_token": {
    "variantID": "__VARIANTID__",
    "variantSecret": "__VARIANT_SECRET__"
  }
}
`;
